import { LoginProps, LoginEditorProps } from './Login.types';

/**
 * 기존 Login 데이터 형식을 새로운 형식으로 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 새로운 컴포넌트용 props
 */
export function adaptLoginProps(originalProps: any): LoginProps {
  // 디버깅용 로그
  
  // 원본 props를 최대한 그대로 반환
  return {
    ...originalProps,
    // 명시적으로 필요한 속성만 보장
    content: originalProps.content || { title: '로그인' },
    style: originalProps.style || {},
    className: originalProps.className || '',
    redirectUrl: originalProps.redirectUrl || '/',
    data: originalProps.data || {},
    componentProps: originalProps.componentProps || {},
    id: originalProps.id || ''
  };
}

/**
 * 에디터용 Login 데이터 형식 변환
 * 
 * @param originalProps 기존 컴포넌트의 props
 * @returns 변환된 에디터 컴포넌트용 props
 */
export function adaptLoginEditorProps(originalProps: any): LoginEditorProps {
  // 기본 props 변환 사용
  const adaptedProps = adaptLoginProps(originalProps) as LoginProps;
  
  // 에디터 관련 추가 props
  return {
    ...adaptedProps,
    isSelected: originalProps.isSelected || false,
    isPreview: originalProps.isPreview || false,
    viewMode: originalProps.viewMode || 'pc',
    updateComponent: originalProps.updateComponent || (() => {})
  };
} 